import { Outlet } from "react-router-dom";
import ConsoleHeader from "./ConsoleHeader";
import ConsoleSidebar from "./ConsoleSidebar";
import OnboardingWizard from "../onboarding/OnboardingWizard";
import AuthModal from "../auth/AuthModal";
import { useAuth } from "../auth/AuthContext";
import "./ConsoleLayout.scss";

/**
 * 控制台整体外壳：
 *   顶部 Header（sticky，始终可见）
 *   下方 body：左侧菜单 + 右侧内容区
 *
 * 未登录时：内容与侧边栏被登录弹窗遮罩覆盖（遮罩铺满 body），仅露出顶部 Header。
 */
const ConsoleLayout = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="cs-console">
      <ConsoleHeader />
      <div className="cs-console__body">
        <ConsoleSidebar />
        <main className="cs-console__main">
          {isAuthenticated ? <Outlet /> : null}
        </main>

        {/* 未登录：登录弹窗覆盖 body（含侧边栏），仅露出顶部导航栏 */}
        {!isAuthenticated && <AuthModal initialView="login" embedded />}
      </div>

      {/* 开屏引导：登录后只弹一次 */}
      <OnboardingWizard />
    </div>
  );
};

export default ConsoleLayout;
